import StruggleToWriteFooter from './StruggleToWriteFooter'
export default StruggleToWriteFooter
